import { createRoute, Navigate } from '@tanstack/react-router';
import LoadingScreen from 'components/LoadingScreen';
import OnboarderLayout from 'layouts/OnboarderLayout';
import { rootRoute } from 'routes/rootRoute';
import { canAccessOnboarderPages, WithEnsure } from 'routes/routeUtils';

export const onboarderParentRoute = createRoute({
  getParentRoute: () => rootRoute,
  component: () => WithEnsure(canAccessOnboarderPages, <OnboarderLayout />),
  path: '/onboarder',
  pendingComponent: LoadingScreen,
});

export const onboarderIndexRoute = createRoute({
  getParentRoute: () => onboarderParentRoute,
  path: '/',
  component: () => <Navigate to="/onboarder/pharmacies" />,
});
